let IS_ENABLED_TESTING_LOCATORS = null;

export const getDataTestID = (testID) =>
  IS_ENABLED_TESTING_LOCATORS
    ? {
        'data-testid': testID,
      }
    : {};

export const getDataEntityID = (entityID) =>
  IS_ENABLED_TESTING_LOCATORS
    ? {
        'data-entityid': entityID,
      }
    : {};

export const getDataTestAttrs = (testID, entityID) => {
  let results = {};

  if (IS_ENABLED_TESTING_LOCATORS === null) {
    IS_ENABLED_TESTING_LOCATORS =
      localStorage.getItem('enableTestingLocators') === 'true';
  }

  if (!IS_ENABLED_TESTING_LOCATORS) {
    return results;
  }

  if (testID) {
    results = { ...results, ...getDataTestID(testID) };
  }
  if (entityID) {
    results = { ...results, ...getDataEntityID(entityID) };
  }

  return results;
};
